import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCheckIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: "100%",
	height: "100%",
	viewBox: "0 0 20 20",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		"data-name": "Icon - Check",
		transform: "translate(-42 -432)",
		children: [/* @__PURE__ */ _jsxs("g", {
			"data-name": "Ellipse 765",
			transform: "translate(42 432)",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1.5,
			children: [/* @__PURE__ */ _jsx("circle", {
				cx: 10,
				cy: 10,
				r: 10,
				stroke: "none"
			}), /* @__PURE__ */ _jsx("circle", {
				cx: 10,
				cy: 10,
				r: 9.25,
				fill: "none"
			})]
		}), /* @__PURE__ */ _jsx("g", {
			"data-name": "Interface-Essential / Navigate / navigation-down-circle",
			transform: "translate(53.126 442) rotate(90)",
			children: /* @__PURE__ */ _jsx("g", {
				"data-name": "Group 742",
				children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("path", {
					"data-name": "Shape 3469",
					d: "M0,5.251,2.626,2.626-3-3",
					fill: "none",
					stroke: "currentColor",
					strokeWidth: 1.5
				}) })
			})
		})]
	})
});
export { SvgCheckIcon as ReactComponent };
